import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderContainer from '../SiteHeader.container';
export default SiteHeaderContainer(SiteHeaderDesktop);
//# sourceMappingURL=index.js.map